
import { CheckHasLowerCaseRegex, checkHasOneNumber, checkHasOneSpecialCharacter, CheckHasUpperCaseRegex } from "./regex"

export function validatePassword(id: number, password: string) {
  switch (id) {
    case 1:
      return password.length >= 8
    case 2:
      return checkHasOneNumber(password)
    case 3:
      return CheckHasUpperCaseRegex.test(password)
    case 4:
      return CheckHasLowerCaseRegex.test(password)
    case 5:
      return checkHasOneSpecialCharacter(password)
    default:
      return false
  }
}
